<template>
  <dara-form v-if="user" :submit="save">
    <div class="row">
      <div class="form-field col-18 col-lg-9">
        <label for="permission" class="w-100 mb-2">
          {{ $t('position') }}
        </label>
        <dara-input
          v-model="user.position"
          :name="$t('position-field')"
          type="text"
          rules="required"
          :placeholder="$t('user-position-placeholder')"
          :disabled="user.permission === 3 && user.id !== performer.id" />
      </div>
    </div>

    <div class="row">
      <div class="form-field col-18 col-lg-9">
        <dara-department-chooser
          ref="departmentChooser"
          v-model="user.department_id"
          @on-change="onDepartmentChange"
          @onNewDepartment="onNewDepartment" />
      </div>
    </div>

    <fieldset v-if="user.permission !== 3" class="form-group" :disabled="user.permission === 3 || company_owner">
      <label for="permission" class="w-100 mb-2">
        {{ $t('permission') }}
      </label>
      <div id="permission" class="form-check form-check-inline">
        <label class="form-check-label">
          <input
            id="readerOption"
            v-model="user.permission"
            type="radio"
            class="form-check-input"
            name="optionsRadios"
            value="0">
          {{ $t('reader') }}
        </label>
      </div>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input
            id="writerOption"
            v-model="user.permission"
            type="radio"
            class="form-check-input"
            name="optionsRadios"
            value="1">
          {{ $t('writer') }}
        </label>
      </div>
      <div class="form-check form-check-inline">
        <label class="form-check-label">
          <input
            id="superUserOption"
            v-model="user.permission"
            type="radio"
            class="form-check-input"
            name="optionsRadios"
            value="2">
          {{ $t('admin') }}
        </label>
      </div>
    </fieldset>

    <div class="mt-4 mb-2 d--flex justify-content-end">
      <dara-button
        class="btn btn-secondary"
        width="110"
        size="sm"
        @click="goHistoryBack()">
        {{ $t('cancel') }}
      </dara-button>
      <dara-button
        native-type="submit"
        class="btn btn-success ms-2"
        width="110"
        size="sm"
        :disabled="user.permission === 3 && user.id !== performer.id">
        {{ $t('save') }}
      </dara-button>
    </div>
    <dara-modal-new-department
      v-if="showModal()"
      ref="departmentModal"
      @close="closeModal()">
    </dara-modal-new-department>
  </dara-form>
</template>

<script>
import { goHistoryBack } from '@/router/route.service';
import { getters } from '@/modules/user/user.store';

import DaraDepartmentChooser from '@/modules/department/components/DepartmentChooser.vue';

export default {
  name: 'DaraUserEditInformation',
  components: {
    DaraDepartmentChooser,
  },
  inject: ['userEditVm'],
  data() {
    return {
      performer: getters.getUser(),
      user: this.userEditVm.user,
      company_owner: this.userEditVm.user.company_owner,
      newDepartment: false,
    };
  },
  methods: {
    goHistoryBack,
    save() {
      this.$emit('save');
    },
    onDepartmentChange(department) {
      this.user.department_id = department.id;
    },
    onNewDepartment() {
      this.newDepartment = true;
    },
    showModal() {
      return this.newDepartment;
    },
    closeModal() {
      this.$refs.departmentChooser.onfetch();
      this.newDepartment = false;
    },
  },
};
</script>
